const state = {
  base: {},
  generateCount: 0,
  newsData: {},
  imageUrlLeft: '',
  imageUrlRight: '',
  cropperVisible: false,
  cropperImg: '',
  addKey: '',
  titleKey: '',
  imgFile: '',
  modelKey: '0',
  unit: 0,
  visibleObj: {},
  weightCostRatio: 0
}
const mutations = {
  setState(state, payload) {
    for (let i in payload) {
      state[i] = payload[i];
    }
  },
  changVal(state,payload){
    let {e,field} = payload || {}
    state.visibleObj[field] = e.target.checked
  }
}

export default {
  namespaced: true,
  state,
  mutations,
}